import { useEffect, useRef, useState } from "react";
import {
  SCOPE_QUESTIONS,
  SCOPE_DEFAULTS,
  LANDSCAPE_INCLUSIONS,
} from "./constants";
import "./styles.css";

const ScopeItems = ({
  projectTypeLabel,
  disabledView = false,
  savedScopeItems,
  onChange,
}) => {
  const label = projectTypeLabel || "";

  const [selections, setSelections] = useState({});
  const [inclusions, setInclusions] = useState([]);

  const prevLabelRef = useRef(null);
  const savedAppliedRef = useRef(false);

  useEffect(() => {
    if (!label || prevLabelRef.current === label) return;
    const prevLabel = prevLabelRef.current;
    prevLabelRef.current = label;

    if (label === "Landscape") {
      setInclusions([]);
    } else {
      setSelections({ ...(SCOPE_DEFAULTS[label] || {}) });
    }

    if (prevLabel) {
      savedAppliedRef.current = true;
    }
  }, [label]);

  useEffect(() => {
    if (savedAppliedRef.current) return;
    if (!savedScopeItems || !label) return;

    savedAppliedRef.current = true;
    if (label === "Landscape") {
      setInclusions(
        Array.isArray(savedScopeItems.inclusions) ? savedScopeItems.inclusions : []
      );
    } else {
      setSelections({ ...(SCOPE_DEFAULTS[label] || {}), ...savedScopeItems });
    }
  }, [savedScopeItems, label]);

  useEffect(() => {
    if (!onChange) return;
    if (!label) {
      onChange(undefined);
      return;
    }
    if (label === "Landscape") {
      onChange({ inclusions });
    } else if (SCOPE_QUESTIONS[label]) {
      onChange(selections);
    } else {
      onChange(undefined);
    }
  }, [selections, inclusions, label]);

  const questions = SCOPE_QUESTIONS[label];
  const isLandscape = label === "Landscape";

  if (!questions && !isLandscape) return null;

  const handleSelect = (key, value) => {
    if (disabledView) return;
    setSelections((prev) => ({ ...prev, [key]: value }));
  };

  const toggleInclusion = (value) => {
    if (disabledView) return;
    setInclusions((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  return (
    <div className="scope-items-section">
      <h3 className="scope-items-title">Scope Items</h3>

      {isLandscape ? (
        <div className="scope-items-group">
          <span className="scope-items-question-label">Inclusions</span>
          <div className="scope-items-options">
            {LANDSCAPE_INCLUSIONS.map((item) => {
              const isSelected = inclusions.includes(item.value);
              return (
                <button
                  key={item.value}
                  type="button"
                  onClick={() => toggleInclusion(item.value)}
                  disabled={disabledView}
                  className={`scope-items-chip ${isSelected ? "selected" : ""} ${
                    disabledView ? "disabled" : ""
                  }`}
                >
                  {item.label}
                  {isSelected && <span className="scope-items-chip-x">×</span>}
                </button>
              );
            })}
          </div>
        </div>
      ) : (
        questions.map((question) => (
          <div key={question.key} className="scope-items-group">
            <div>
              <span className="scope-items-question-label">{question.label}</span>
              {question.description && (
                <p className="scope-items-question-desc">{question.description}</p>
              )}
            </div>
            <div className="scope-items-options">
              {question.options.map((opt) => {
                const isSelected = selections[question.key] === opt.value;
                return (
                  <button
                    key={opt.value}
                    type="button"
                    onClick={() => handleSelect(question.key, opt.value)}
                    disabled={disabledView}
                    className={`scope-items-chip small ${
                      isSelected ? "selected" : ""
                    } ${disabledView ? "disabled" : ""}`}
                  >
                    {opt.label}
                  </button>
                );
              })}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ScopeItems;
